import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, User } from "lucide-react";
import { AuthNav } from "@/components/AuthNav";
import { useSupabase } from "@/hooks/useSupabase";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const { isLoggedIn } = useSupabase();

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/" className="flex items-center">
                <span className="text-2xl font-bold bg-gradient-to-r from-ai-indigo to-ai-purple bg-clip-text text-transparent">
                  AI Nexus
                </span>
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <Link 
                to="/" 
                className={`inline-flex items-center px-1 pt-1 border-b-2 ${
                  isActive('/') 
                    ? 'border-ai-indigo text-gray-900' 
                    : 'border-transparent text-gray-500 hover:border-ai-indigo hover:text-gray-900'
                }`}
              >
                Home
              </Link>
              <Link 
                to="/articles" 
                className={`inline-flex items-center px-1 pt-1 border-b-2 ${
                  isActive('/articles') 
                    ? 'border-ai-indigo text-gray-900' 
                    : 'border-transparent text-gray-500 hover:border-ai-indigo hover:text-gray-900'
                }`}
              >
                Feed
              </Link>
              <Link 
                to="/about" 
                className={`inline-flex items-center px-1 pt-1 border-b-2 ${
                  isActive('/about') 
                    ? 'border-ai-indigo text-gray-900' 
                    : 'border-transparent text-gray-500 hover:border-ai-indigo hover:text-gray-900'
                }`}
              >
                About
              </Link>
            </div>
          </div>
          <div className="hidden sm:ml-6 sm:flex sm:items-center">
            {isLoggedIn && (
              <Link 
                to="/account" 
                className={`inline-flex items-center px-3 py-1 mr-4 rounded-md ${
                  isActive('/account') 
                    ? 'bg-gray-100 text-gray-900' 
                    : 'text-gray-500 hover:bg-gray-100 hover:text-gray-900'
                }`}
              >
                <User className="w-5 h-5 mr-1" />
                Account
              </Link>
            )}
            <AuthNav />
          </div>
          <div className="-mr-2 flex items-center sm:hidden">
            <button
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-ai-indigo"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span className="sr-only">Open main menu</span>
              {isMenuOpen ? (
                <X className="block h-6 w-6" aria-hidden="true" />
              ) : (
                <Menu className="block h-6 w-6" aria-hidden="true" />
              )}
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="sm:hidden">
          <div className="pt-2 pb-3 space-y-1">
            <Link
              to="/"
              className={`block pl-3 pr-4 py-2 border-l-4 ${
                isActive('/') 
                  ? 'border-ai-indigo text-gray-900 bg-gray-50' 
                  : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-ai-indigo hover:text-gray-900'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/articles"
              className={`block pl-3 pr-4 py-2 border-l-4 ${
                isActive('/articles') 
                  ? 'border-ai-indigo text-gray-900 bg-gray-50' 
                  : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-ai-indigo hover:text-gray-900'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Feed
            </Link>
            <Link
              to="/about"
              className={`block pl-3 pr-4 py-2 border-l-4 ${
                isActive('/about') 
                  ? 'border-ai-indigo text-gray-900 bg-gray-50' 
                  : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-ai-indigo hover:text-gray-900'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              About
            </Link>
            {isLoggedIn && (
              <Link
                to="/account"
                className={`block pl-3 pr-4 py-2 border-l-4 ${
                  isActive('/account') 
                    ? 'border-ai-indigo text-gray-900 bg-gray-50' 
                    : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-ai-indigo hover:text-gray-900'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                Account
              </Link>
            )}
          </div>
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="space-y-1">
              <AuthNav />
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
